import React from "react";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { getTheme } from "./theme";

/**
 * App-level MUI theme provider. Wrap once at root.
 * For dark mode: pass mode="dark" or use state (e.g. from user preference).
 */
export default function AppThemeProvider({ children, mode = "light" }) {
  const theme = React.useMemo(() => getTheme(mode), [mode]);
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
